import { AboutSection } from "./components/AboutSection";
import { BrandPortfolio } from "./components/BrandPortfolio";
import { BrandDetailPage } from "./components/brands/BrandDetailPage";
import { BrandIndexPage } from "./components/brands/BrandIndexPage";
import { BusinessScopeSection } from "./components/BusinessScopeSection";
import { ContactSection } from "./components/ContactSection";
import { CompanyVerificationPage } from "./components/company/CompanyVerificationPage";
import { Footer } from "./components/Footer";
import { GlobalNetwork } from "./components/GlobalNetwork";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { InsightsSection } from "./components/InsightsSection";
import { IntelligenceNode } from "./components/IntelligenceNode";
import { IndustryReadDetailPage } from "./components/news/IndustryReadDetailPage";
import { NewsDetailPage } from "./components/news/NewsDetailPage";
import { brandDirectoryMap } from "./data/brandDirectory";
import { LocaleProvider } from "./i18n/LocaleContext";
import { parseSitePath } from "./lib/siteRouting";
import { useEffect, useState } from "react";

function AppBody() {
  const [pathname, setPathname] = useState(window.location.pathname);

  useEffect(() => {
    const onPopState = () => setPathname(window.location.pathname);
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  const { contentPath } = parseSitePath(pathname);
  const isBrandIndex = contentPath === "/brands";
  const isCompanyVerification = contentPath === "/company/verification";
  const brandMatch = contentPath.match(/^\/brands\/([^/]+)$/);
  const brand = brandMatch ? brandDirectoryMap[brandMatch[1]] : null;
  const newsMatch = contentPath.match(/^\/news\/([^/]+)$/);
  const newsSlug = newsMatch ? newsMatch[1] : null;
  const industryMatch = contentPath.match(/^\/industry\/([^/]+)$/);
  const industrySlug = industryMatch ? industryMatch[1] : null;

  return (
    <div className="min-h-screen bg-[linear-gradient(180deg,rgba(251,253,254,0.96)_0%,rgba(243,248,251,0.9)_24%,rgba(236,243,247,0.92)_58%,rgba(227,236,242,0.98)_100%)] text-[#1f2b31]">
      <Header />
      {isCompanyVerification ? (
        <CompanyVerificationPage />
      ) : isBrandIndex ? (
        <BrandIndexPage />
      ) : newsSlug ? (
        <NewsDetailPage slug={newsSlug} />
      ) : industrySlug ? (
        <IndustryReadDetailPage slug={industrySlug} />
      ) : brand ? (
        <BrandDetailPage brand={brand} />
      ) : (
        <main>
          <HeroSection />
          <BrandPortfolio />
          <AboutSection />
          <BusinessScopeSection />
          <IntelligenceNode />
          <GlobalNetwork />
          <InsightsSection />
          <ContactSection />
        </main>
      )}
      <Footer />
    </div>
  );
}

function CorporateApp() {
  return (
    <LocaleProvider>
      <AppBody />
    </LocaleProvider>
  );
}

export default CorporateApp;
